import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X, LogIn, LayoutDashboard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth, dashboardPath } from "@/context/AuthContext";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/come-funziona", label: "Come funziona" },
  { to: "/per-bnb", label: "Per i B&B" },
  { to: "/per-bar", label: "Per bar e pasticcerie" },
  { to: "/pacchetti", label: "Pacchetti" },
  { to: "/diventa-partner", label: "Diventa partner" },
  { to: "/contatti", label: "Contatti" },
];

export function Logo({ className = "h-11" }) {
  return (
    <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
      <img src="/morningbox-logo.png" alt="MorningBox" className={`${className} w-auto object-contain`} />
    </Link>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const goPartner = () => {
    if (user) navigate(dashboardPath(user.role));
    else navigate("/accedi");
  };

  return (
    <header className="glass-nav sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between">
        <Logo />
        <div className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => {
            const active = location.pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`px-3 py-2 rounded-full text-sm font-medium transition-colors ${
                  active ? "text-orange bg-orange/10" : "text-navy/70 hover:text-navy hover:bg-navy/5"
                }`}
              >
                {l.label}
              </Link>
            );
          })}
        </div>
        <div className="hidden lg:flex items-center gap-2">
          <Button
            variant="ghost"
            data-testid="nav-login-btn"
            className="rounded-full text-navy hover:bg-navy/5"
            onClick={() => navigate("/accedi")}
          >
            <LogIn className="w-4 h-4 mr-1" /> Accedi
          </Button>
          <Button
            data-testid="nav-partner-area-btn"
            className="rounded-full bg-navy hover:bg-navy-700 text-white"
            onClick={goPartner}
          >
            <LayoutDashboard className="w-4 h-4 mr-1" /> Area Partner
          </Button>
        </div>
        <button className="lg:hidden text-navy" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </nav>
      {open && (
        <div className="lg:hidden bg-white border-t border-navy/5 px-5 py-4 space-y-1" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="block px-3 py-2.5 rounded-lg text-navy font-medium hover:bg-cream">
              {l.label}
            </Link>
          ))}
          <div className="flex gap-2 pt-2">
            <Button variant="outline" className="flex-1 rounded-full" onClick={() => { setOpen(false); navigate("/accedi"); }}>Accedi</Button>
            <Button className="flex-1 rounded-full bg-navy text-white" onClick={() => { setOpen(false); goPartner(); }}>Area Partner</Button>
          </div>
        </div>
      )}
    </header>
  );
}
